<template>
    <dash
        icon="fa fa-info-circle"
        titulo="ATUALIZAÇÕES CADASTRAIS"
        @click.native="$router.push({ name: 'GestaoAtualizacoesCadastrais' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	props: {
		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
